import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CallingIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CallSettingsIcon() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: CallingIcon,
      size: "300",
      color: "fill-accent-blue-default",
      marginInlineEnd: "100",
      paddingBlock: "0",
      paddingInline: "0"
    }), /*#__PURE__*/_jsx(Text, {
      display: "inline-block",
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calling-ui-library.callee-select.call"
      })
    })]
  });
}
export default /*#__PURE__*/memo(CallSettingsIcon);